/**
	MAIN.JS

    In this file, all used JavaScript modules come together ans one, as they are initialized right here.
 */
'use strict';

import Accordion from './modules/accordion';
import CookieByte from './modules/cookie-byte';
import Form from './form/form';
import HeaderMenu from './navigation/header-menu';
import MediaViewer from './modules/media-viewer';
import Modal from './modules/modal';
import ResponsiveImage from './modules/responsive-image';
import Video from './modules/video';
import NumberAnimation from './modules/number-animation';
import HeroNico from './modules/hero-nico';
import SliderMartin from './modules/slider-martin';
import SliderAlbert from './modules/slider-albert';
import AOSClass from './modules/aos';
import Maps from './modules/maps';
import ChartClass from './modules/chart';

const siteInitialization = () => {
	CookieByte.init();
	HeaderMenu.init();
	Accordion.initAll();
	ResponsiveImage.initAll();
	MediaViewer.init();
	Modal.initAll();
	Form.init();
	Video.initAll();
	NumberAnimation.init();
	HeroNico.init();
	SliderMartin.initAll();
	SliderAlbert.initAll();
	Maps.init('AIzaSyASLp9enx9b6DizNDhz1I6esvnslyqcZDQ');
	ChartClass.init();
	AOSClass.init();
};

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') siteInitialization();
else document.addEventListener('DOMContentLoaded', siteInitialization);
